import Swiper from 'swiper/bundle';
import Alpine from 'alpinejs';
import Drift from 'drift-zoom';

Alpine.data('product_gallery', () => ({
  swiperReference: null,
  init() {
    this.initSlider();
    let self = this;
    window.productGalleryGoToSlide = (index) => self.goToSlide(index);
  },
  initSlider() {
    this.swiperReference = new Swiper(this.$refs.swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: this.$refs.pagination,
        clickable: true,
      },
      navigation: {
        nextEl: this.$refs.next_arrow,
        prevEl: this.$refs.prev_arrow,
      },
    });
  },
  goToSlide(index) {
    let index0 = parseInt(index) - 1;
    this.swiperReference.slideTo(index0);
  },
}));

function get_product_obj(handle) {
  const product_variant_obj = {
    init_loaded: false,
    currentVariant: null,
    variants: [],
    images: [],
    cart: {},
    selected_options: {},
    selected_color_code: null,
    loaded_variants: false,
    is_out_of_stock: false,
    atc_messages: {
      valid_variant: 'AGREGAR AL CARRITO',
      out_of_stock: 'AGOTADO',
      select_size: 'SELECCIONAR TALLE',
      all_oos: 'VER ARTÍCULOS SIMILARES',
    },
    atc_short_messages: {
      valid_variant: 'AGREGAR',
      out_of_stock: 'AGOTADO',
      select_size: 'SELECCIONAR',
      all_oos: 'VER SIMILARES',
    },
    variants_context: null,
    pdp_container: null,
    product_id: null,
    section_id: null,
    jean_size: null,
    product_swatches: [],
    async getVariants(product_id) {
      window.product_variants = window.product_variants || {};
      if (window.product_variants[product_id]) {
        return window.product_variants[product_id];
      }
      const query = `
      query getProductById($id: ID!) {
        product(id: $id) {
          images(first: 100) {
            edges {
              node {
                url
                altText
              }
            }
          }
          variants(first: 100){
            edges {
              node {
                id
                selectedOptions{  
                  name
                  value
                }
                quantityAvailable
                colorCode: metafield(namespace: "custom", key: "color_code") {
                  value
                }
              }
            }              
          }
        }
      }
    `;

      const variables = {
        id: `gid://shopify/Product/${product_id}`,
      };

      const data = await window.fetchStoreFront({
        query,
        variables,
      });

      if (this.variants_context != 'ajax') {
        this.images = data?.product?.images.edges.map((image) => image.node);
      }

      const variants = data?.product?.variants.edges
        .map((variant) => variant.node)
        .map((variant) => ({ ...variant, id: variant.id.split('/').pop() }))
        .map((variant) => {
          return {
            id: variant.id,
            options: variant.selectedOptions.map((option) => option.value),
            quantity: variant?.quantityAvailable || 0,
            color_code: variant?.colorCode?.value || null,
          };
        });

      window.product_variants[product_id] = variants;
      return variants;
    },

    async init() {
      const url = new URL(window.location.href);
      if (!url.pathname.includes('/products/')) return;

      const pdp_container = document.querySelector('[pdp-container]');
      if (!pdp_container) return;

      this.pdp_container = pdp_container;

      const variants_context = pdp_container.getAttribute('variants-context');
      this.variants_context = variants_context;

      const product_id = pdp_container.getAttribute('product-id');
      this.product_id = product_id;

      const section_id = pdp_container.getAttribute('section-id');
      this.section_id = section_id;

      this.cart = window.cart_object;
      const events = ['cart:init', 'cart:updated'];
      events.forEach((event) => {
        document.addEventListener(event, () => {
          this.cart = window.cart_object;
          this.updateCurrentVariant();
        });
      });

      this.variants = await this.getVariants(product_id);

      this.updateGallery();

      if (this.variants_context === 'ajax') {
        this.loadColorVariants();
        this.popStateHandler();
      }

      setTimeout(() => {
        this.updateCurrentVariant();
        this.loaded_variants = true;
      }, 100);
    },
    loadColorVariants() {
      const productSwatches = Array.from(document.querySelectorAll('[product-swatch]') ?? []);
      const swatchesToLoad = Array.from(
        new Set(
          productSwatches.map((swatch) => {
            return {
              url: swatch.href,
              id: swatch.getAttribute('product-id'),
            };
          })
        )
      );

      this.product_swatches = swatchesToLoad;
      const currentHTML = this.pdp_container.innerHTML;
      window.product_variations_html = {
        [this.product_id]: currentHTML,
      };

      this.preloadHTML();
      this.preloadVariants();
    },
    async preloadHTML() {
      const swatches = this.product_swatches;
      await Promise.all(
        swatches.map(async (swatch) => {
          const href = swatch.url;
          const id = swatch.id;
          const url = `${href}?sections=${this.section_id}&request_context=${this.variants_context}`;
          const response = await fetch(url);
          const data = await response.json();
          window.product_variations_html[id] = data[this.section_id];
        })
      );
    },
    async preloadVariants() {
      const swatches = this.product_swatches;
      await Promise.all(
        swatches.map(async (swatch) => {
          const id = swatch.id;
          await this.getVariants(id);
        })
      );
    },
    selectProduct(id) {
      console.log('selectProduct', id);
      if (id == this.product_id) return;

      const html = window.product_variations_html[id];
      if (!html) return;

      const variants = window.product_variants[id];
      if (!variants) return;

      this.updateURL(id);

      let oldSize = this.selected_options['Talla'];
      if (!oldSize && variants.length > 0) {
        oldSize = variants[0].options[1];
      }

      this.product_id = id;
      this.variants = variants;
      this.loaded_variants = true;
      this.selected_options = {};
      this.pdp_container.innerHTML = html;
      this.currentVariant = null;
      this.is_out_of_stock = false;

      if (!oldSize) {
        this.jean_size = null;
        return;
      }

      let variant = this.variants.find((variant) => {
        return variant.options.includes(oldSize);
      });

      if (!variant) {
        this.jean_size = null;
        return;
      }

      if (variant?.quantity <= 0) {
        this.jean_size = null;
      }

      const cart = this.cart;
      if (!cart?.items) return;

      if (!variant) {
        variant = this.variants[0];
        oldSize = variant.options[1];
      }

      const items = cart.items.filter((item) => item.variant_id == variant.id);
      const cart_item_quantity = items.reduce((acc, item) => acc + item.quantity, 0);
      if (cart_item_quantity >= variant.quantity) {
        this.jean_size = null;
        return;
      }
      this.selectOption({ name: 'Talla', value: oldSize });
      setTimeout(() => {
        initializeDrift();
      }, 500);
    },
    updateURL(product_id) {
      const href = this.product_swatches.find((swatch) => swatch.id == product_id).url;
      if (!href) return;
      const url = new URL(href);
      const new_url = new URL(window.location.href);
      new_url.pathname = url.pathname;
      new_url.search = url.search;
      window.history.pushState({}, '', new_url);
    },
    popStateHandler() {
      window.addEventListener('popstate', () => {
        const url = new URL(window.location.href);
        if (!url.pathname.includes('/products/')) return;
        url.search = '';
        const href = url.href;
        const product_id = this.product_swatches.find((swatch) => swatch.url == href)?.id;
        if (!product_id) return;
        this.selectProduct(product_id);
      });
    },
    async handleInit() {
      if (this.init_loaded) return;
      this.init_loaded = true;
      const url = new URL('/products/' + this.handle, window.location.origin);
      const path = url.pathname;
      const new_path = `${path}.js`;
      const response = await fetch(new_path);
      const data = await response.json();
      this.variants = data.variants;
      this.cart = window.cart_object;
      this.variants = await this.getVariants(data.id);
      this.updateGallery();
      setTimeout(() => {
        this.updateCurrentVariant();
        this.loaded_variants = true;
        const events = ['cart:init', 'cart:updated'];
        events.forEach((event) => {
          document.addEventListener(event, () => {
            this.cart = window.cart_object;
            this.updateCurrentVariant();
          });
        });
      }, 100);
    },
    ATCMessage(short_message = false) {
      const messages = short_message ? this.atc_short_messages : this.atc_messages;
      if (!this.loaded_variants) {
        return messages.valid_variant;
      }
      if (this.currentVariant && !this.is_out_of_stock) {
        return messages.valid_variant;
      }
      if (Object.values(this.selected_options).some((option) => !option)) {
        // Check if ALL variants are out of stock
        const allVariantsOutOfStock = this.variants && this.variants.every((variant) => variant.quantity <= 0);
        if (allVariantsOutOfStock) {
          return messages.all_oos;
        } else {
          return messages.select_size;
        }
      }

      return messages.out_of_stock;
    },
    isValidSize(size) {
      const possible_variants = this.variants?.filter((variant) => {
        const selectedColor = this.selected_options['Color'];
        return variant.options.includes(selectedColor);
      });

      if (possible_variants) {
        return possible_variants.some((variant) => variant.options.includes(size));
      }
      return false;
    },
    isAvailableSize(size) {
      const currentColor = this.selected_options['Color'];

      const variant = this.variants.find((variant) => {
        return variant.options.includes(currentColor) && variant.options.includes(size);
      });

      if (!variant) return false;
      if (variant?.quantity <= 0) return false;

      const cart = this.cart;
      if (!cart?.items) return true;
      const items = cart.items.filter((item) => item.variant_id == variant.id);
      const cart_item_quantity = items.reduce((acc, item) => acc + item.quantity, 0);
      return cart_item_quantity < variant.quantity;
    },
    isAvailableJeanSize(size) {
      const currentColor = this.selected_options['Color'];

      // Find all variants that match the current color and the given size (regardless of length)
      const availableVariants = this.variants.filter((variant) => {
        const [variantSize] = variant.options.find((opt) => opt.includes('-'))?.split('-') || [];
        return variant.options.includes(currentColor) && variantSize === size;
      });

      if (availableVariants.length === 0) return false;

      // Check if any of the variants with this size have available stock
      const hasAvailableStock = availableVariants.some((variant) => {
        if (variant.quantity <= 0) return false;

        // Check cart quantities
        if (!this.cart?.items) return true;
        const cartItems = this.cart.items.filter((item) => item.variant_id == variant.id);
        const cartItemQuantity = cartItems.reduce((acc, item) => acc + item.quantity, 0);
        return cartItemQuantity < variant.quantity;
      });

      return hasAvailableStock;
    },
    addOption(optionName) {
      console.log('addOption', optionName);
      if (this.selected_options[optionName]) return;
      this.selected_options[optionName] = null;
    },
    selectOption({ name, value }) {
      console.log('selectOption', name, value);
      this.selected_options[name] = value;
      if (name == 'Color') {
        const availableVariants = this.variants?.filter((variant) => {
          return variant.options.includes(value) && variant.options.length > 1;
        });

        if (availableVariants.length === 0) {
          this.updateCurrentVariant();
          return;
        }

        if (this.variants_context === 'ajax') {
          return;
        }

        const currentSizeInNewColor = availableVariants.find((variant) => {
          return variant.options.includes(this.selected_options['Talla']);
        });

        if (currentSizeInNewColor) {
          this.selectOption({ name: 'Talla', value: this.selected_options['Talla'] });
          this.updateGallery();
          return;
        }

        if (!currentSizeInNewColor) {
          const availableSize = availableVariants[0].options.find((option) => option !== value);
          this.selectOption({ name: 'Talla', value: availableSize });
          this.updateGallery();
        }
      } else {
        this.updateCurrentVariant();
      }
    },
    updateCurrentVariant() {
      // Check if "Denominaciones" is the only relevant option - Gift Cards
      if (this.selected_options['Denominaciones']) {
        this.currentVariant = this.variants?.find((variant) => {
          return variant.options.includes(this.selected_options['Denominaciones']) && variant.quantity > 0;
        });
      } else {
        // Default behavior for other cases
        this.currentVariant = this.variants?.find((variant) => {
          return (
            Object.keys(this.selected_options).every((key) => {
              const selectedValue = this.selected_options[key];
              return variant.options.includes(selectedValue);
            }) && variant.quantity > 0
          );
        });
      }
      if (!this.cart?.items || !this.currentVariant) return;

      const cart = this.cart;
      const items = cart.items.filter((item) => item.variant_id == this.currentVariant.id);
      const cart_item_quantity = items.reduce((acc, item) => acc + item.quantity, 0);
      this.is_out_of_stock = cart_item_quantity >= this.currentVariant.quantity;
    },
    updateGallery() {
      if (this.variants_context === 'ajax') return;

      scrollTo(0, 0);

      const possible_variant = this.variants?.find((variant) => {
        return Object.keys(this.selected_options).every((key) => {
          const selectedValue = this.selected_options[key];
          if (selectedValue) {
            return variant.options.includes(selectedValue);
          }
          return true;
        });
      });

      if (!possible_variant) return;

      const selectedColorCode = possible_variant?.color_code;
      if (!selectedColorCode) return;

      const productThumbnails = document.querySelector('#ProductThumbsSwiper');
      const productImages = document.querySelector('#ProductImagesSwiper');
      if (!productThumbnails || !productImages) return;

      const gallery_has_at_least_one_image =
        productImages.querySelectorAll(`[data-color-code="${selectedColorCode}"]`).length > 0;
      if (!gallery_has_at_least_one_image) return console.error('Color code not found in gallery');

      const thumbnail_slides = productThumbnails?.querySelectorAll('[data-color-code]');

      thumbnail_slides.forEach((slide) => {
        if (slide.dataset.colorCode === selectedColorCode) {
          slide.classList.remove('!hidden');
          slide.classList.add('swiper-slide');
        } else {
          slide.classList.add('!hidden');
          slide.classList.remove('swiper-slide');
        }
      });

      const main_slides = productImages.querySelectorAll('[data-color-code]');

      main_slides.forEach((slide) => {
        if (slide.dataset.colorCode === selectedColorCode) {
          slide.classList.remove('!hidden');
          slide.classList.add('swiper-slide');
        } else {
          slide.classList.add('!hidden');
          slide.classList.remove('swiper-slide');
        }
      });

      setTimeout(() => {
        productThumbnails.swiper.slideTo(0);
        productThumbnails.swiper.update();
        productImages.swiper.slideTo(0);
        productImages.swiper.update();
      }, 250);
    },
  };

  if (handle) {
    product_variant_obj.handle = handle;
    delete product_variant_obj.init;
    delete product_variant_obj.updateGallery;
    product_variant_obj.updateGallery = function () {
      const possible_variant = this.variants?.find((variant) => {
        return Object.keys(this.selected_options).every((key) => {
          const selectedValue = this.selected_options[key];
          return variant.options.includes(selectedValue);
        });
      });
      if (!possible_variant) return;

      const selectedColorCode = possible_variant?.color_code;
      if (!selectedColorCode) return;

      const images = this.images;

      const featured_image = this.$refs.featured_image;
      const secondary_image = this.$refs.secondary_image;
      if (!featured_image) return;

      const filtered_images = images.filter((image) => image.altText.includes(selectedColorCode));
      if (filtered_images.length === 0) return;

      featured_image.src = filtered_images[0].url;
      featured_image.removeAttribute('srcset');
      if (!secondary_image) return;

      secondary_image.src = filtered_images[1]?.url || filtered_images[0].url;
      secondary_image.removeAttribute('srcset');
    };
  }

  return product_variant_obj;
}

function initializeDrift() {
  const driftImgs = document.querySelectorAll('.lightbox-slide img');
  // const pane = document.querySelector('.drift-pane');

  driftImgs.forEach((img) => {
    new Drift(img, {
      // paneContainer: pane,
      inlinePane: true,
    });
  });
}

document.addEventListener('DOMContentLoaded', initializeDrift);

Alpine.store('product', get_product_obj());
Alpine.data('variant_picker', (handle) => ({ ...get_product_obj(handle) }));
